// extracted by mini-css-extract-plugin
export default {"tierGroup":"TierGroup-module__tierGroup_Eg9F8"};